// extracted by mini-css-extract-plugin
module.exports = {"categories":"categories-module--categories--2xGBI","parentCat":"categories-module--parentCat--2eUBi","allLink":"categories-module--allLink--2b6W1"};